module.exports = __webpack_public_path__ + "img/H-B-5-unload-connect-shadow.19d301d0.png";